import {TextField} from '@mui/material';
import {GridFilterInputValueProps} from '@mui/x-data-grid';
import {t} from 'i18next';
import React, {ChangeEvent, useState} from 'react';

interface CustomFilterInputProps {
  params: GridFilterInputValueProps;
  type: string;
  loader: boolean;
}

const CustomFilterInput = (props: CustomFilterInputProps) => {
  const {item, applyValue} = props.params;
  const type = props.type;
  const loader = props.loader;
  const [value, setValue] = useState(item.value ? item.value : '');

  const inputRef: React.Ref<HTMLInputElement> = React.useRef(null);

  const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    setValue(target.value);
    applyValue({...item, value: target.value});
  };

  return (
    <>
      <TextField
        type={type}
        inputRef={inputRef}
        value={value}
        variant="standard"
        size="small"
        placeholder={t('ecaDocList.filters.valueLabel')}
        label={t('ecaDocList.filters.value')}
        fullWidth
        onChange={handleFilterChange}
        InputLabelProps={{shrink: true}}
        autoFocus
        disabled={loader}
      />
    </>
  );
};

export default CustomFilterInput;
